import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../../auth/auth-guard.service';
import { SouscriptionComponent } from './souscription.component';
import { SouscriptionsComponent } from './souscriptions.component';

const routes: Routes = [
  {
    path: '',
    component: SouscriptionsComponent, canActivate: [AuthGuard],
    data: { permissions: ['adminAccess']},
    children: [

      {
        path: 'liste',
        component: SouscriptionComponent,
        canActivate: [AuthGuard],
        data: { permissions: ['adminAccess', 'adminEditUser']},
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SouscriptionsRoutingModule { }

export const routedComponents = [
  SouscriptionsComponent,
  SouscriptionComponent
];
